export default "__VITE_ASSET__DP5tSA4b__"